import React from 'react';
import { AlertTriangleIcon, CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { purchaseUrl } from '../data/content';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
const included = ['4 Módulos completos: Descompresión, Desbloqueo, Fortalecimiento y Mantenimiento', 'BONO 1 — Kit Anticrisis Lumbar (gratis)', 'BONO 2 — Oficina Sin Dolor Lumbar (gratis)', 'BONO 3 — Mañanas Sin Rigidez Lumbar (gratis)', 'Garantía de 7 días'];
type PricingProps = {
  /** Anchor id. The first instance owns "pricing" so every CTA scrolls there. */
  anchorId?: string;
};
export function Pricing({
  anchorId = 'pricing'
}: PricingProps) {
  const titleId = `${anchorId}-title`;
  return <section id={anchorId} className="scroll-mt-20 bg-canvas px-4 py-14 md:py-16" aria-labelledby={titleId} data-id="element-203" data-mp="aekjxtdyx0dl">
      <div className="mx-auto max-w-2xl text-center" data-id="element-204" data-mp="2v37a854tmvtj">
        <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-primary md:text-sm" data-id="element-205" data-mp="2v0uln94k5n7i">
          ⏰ Precio de lanzamiento — cierra en:
        </p>
        <div className="mt-4" data-id="element-206" data-mp="2apt1g9tyj7i2">
          <Countdown data-id="element-207" data-mp="2aqm1kryeuyr8" />
        </div>
        <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-red-200 bg-red-50 px-4 py-2 text-xs font-extrabold text-red-600" data-id="element-208" data-mp="2oosdmi0a9txc">
          <AlertTriangleIcon className="h-4 w-4" data-id="element-209" data-mp="2kldyruo2zjlh" />
          Después sube $3.000 ARS. No vuelve.
        </p>

        <article className="mt-8 rounded-3xl border-4 border-primary bg-white p-6 text-left shadow-[0_24px_60px_rgba(29,78,216,.20)] md:p-9" data-id="element-210" data-mp="2ykdkatgaridf">
          <div className="text-center" data-id="element-211" data-mp="38crt265slp93">
            <span className="inline-flex rounded-full bg-primary px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wide text-white" data-id="element-212" data-mp="38bgmjykyq3ea">
              🔥 Precio especial de lanzamiento
            </span>
            <h2 id={titleId} className="mt-4 text-xl font-black text-ink md:text-3xl" data-id="element-213" data-mp="3hd7ula2z6mbb">
              Acceso a los 4 módulos + 3 bonos GRATIS
            </h2>
          </div>

          <ul className="my-7 space-y-2.5 border-y border-sky-100 py-6" data-id="element-214" data-mp="2a1qgprttkom1">
            {included.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-slate-700" data-id="element-215" data-mp="2f01uuer5dla2">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-primary" data-id="element-216" data-mp="2izu30qcmppew" />
                {item}
              </li>)}
          </ul>

          <div className="text-center" data-id="element-217" data-mp="2srgaqcprd6cw">
            <p className="text-base font-bold text-slate-400 line-through" data-id="element-218" data-mp="2sqey43t3gbt2">$53.990</p>
            <p className="text-[11px] font-extrabold uppercase tracking-wide text-slate-500" data-id="element-219" data-mp="2xoq9wk2y8wdx">Hoy</p>
            <p className="text-4xl font-black text-primary md:text-6xl" data-id="element-220" data-mp="32qfno7hk3o5p">$19.990 ARS</p>
            <div className="mt-6" data-id="element-221" data-mp="36pofv7wy7dz5">
              <Button href={purchaseUrl} fullWidth className="text-sm md:text-lg" data-id="element-222" data-mp="36pwrkwhc4d8r">
                💪 QUIERO MI COMBO LUMBAR AHORA →
              </Button>
            </div>
            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-slate-500" data-id="element-223" data-mp="1cdgepcu1a0ux">
              <span className="flex items-center gap-1" data-id="element-224" data-mp="14v8pqeofo109">
                <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-225" data-mp="101eabnfv286z" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-226" data-mp="v45s5mupq45q">
                <ZapIcon className="h-3.5 w-3.5 text-primary" data-id="element-227" data-mp="r1r6kuznsqar" /> Acceso en 5 minutos
              </span>
              <span className="flex items-center gap-1" data-id="element-228" data-mp="1nrrt0nck2uow">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-229" data-mp="1nr8nk643dyrr" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-230" data-mp="1iqud6hf0qcqk">
                <CreditCardIcon className="h-3.5 w-3.5 text-primary" data-id="element-231" data-mp="1eqah7h66lf60" /> Mercado Pago · Tarjeta ·
                Transferencia
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}